import { CartLineProvider, Link, Money, useCart, useLocalization } from '@shopify/hydrogen'
import { MiniCartLineItem } from './mini-cart-line-item.client'
import styles from '../../assets/scss/components/cart/mini-cart.module.scss'
import { useI18n } from '../i18n.client'
import { useContext } from 'react'
import { HeaderContext } from '../header/header-provider.client'
import { useTracking } from '../../lib/hooks/tracking.client'

export const MiniCart: React.FC = () => {
  const [i18n] = useI18n()
  const { setIsCartDrawerOpen } = useContext(HeaderContext)
  const { checkoutUrl, cost, lines } = useCart()
  const {
    country: { isoCode: country },
  } = useLocalization()
  const { trackEvent } = useTracking()

  const handleClick = () => {
    trackEvent('view_basket')
    setIsCartDrawerOpen(false)
  }

  return (
    <div className={styles.miniCart}>
      <div className={styles.header}>
        <h1 className={styles.title}>{i18n.translate('basket')}</h1>
        <div className={styles.close} onClick={() => setIsCartDrawerOpen(false)}>
          {i18n.translate('close')}
        </div>
      </div>
      <div className={styles.scrollContainer}>
        {lines.map((line) => (
          <CartLineProvider key={line.id} line={line}>
            <MiniCartLineItem />
          </CartLineProvider>
        ))}
      </div>
      <div>
        {country != 'US' && (
          <div className={styles.almaPaymentInformation}>
            <img className={styles.almaPaymentImage} height={32} src="/alma-payment-information.png" width={130} />
            <p dangerouslySetInnerHTML={{ __html: i18n.translate('alma-payment-information') }} />
          </div>
        )}
        <div className={styles.subtotal}>
          {i18n.translate('subtotal')}
          {cost?.subtotalAmount?.amount && <Money data={cost?.subtotalAmount} withoutTrailingZeros />}
        </div>
        <div className={styles.subtotalSmallPrint}>
          {i18n.translate('tax-included-and-shipping-calculated-at-checkout')}
        </div>
        {checkoutUrl && (
          <>
            <Link className={styles.checkoutButton} onClick={handleClick} to="/cart">
              {i18n.translate('view-basket')}
            </Link>

            <Link className={styles.checkoutButton} to={checkoutUrl} prefetch={false}>
              {i18n.translate('checkout_proceed')}
            </Link>
          </>
        )}
      </div>
    </div>
  )
}
